import * as React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { useSelector } from "react-redux";
import { toastSelector } from "../../../store/helpers/helperSelectors";
import { useStoreDispatch } from "../../../store/hooks";
import { setOpenToast } from "../../../store/helpers/helperReducers";

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const formatMessage = (message: string) => {
  const chars = message.split('\\n');
  if(chars?.length > 0) {
    return chars?.map((line, index) => (
      <span  key={index}>
        {line}
        <br/>
      </span>
    ));
  }
  else return message;
};

const Toast = () => {
  const dispatch = useStoreDispatch();
  const { openToast, message, toastType } = useSelector(toastSelector);

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(setOpenToast({ openToast: false }));
  };
  if (openToast) {
    const closeIn = message.toString().length >= 100 ? 10000 : 5000;
    setTimeout(() => {
      handleClose();
    }, closeIn);
  }
  return (
    toastType && (
      <Snackbar
        //autoHideDuration={4000}
        open={openToast}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ zIndex: 2200 }}
      >
        <Alert onClose={handleClose} severity={toastType} sx={{ width: "100%" }} variant="filled">
          {formatMessage(message)}
        </Alert>
      </Snackbar>
    )
  );
};

export default Toast;
